/** Created by azhou on 2019/2/18.*/
<template>
  <div class="arr-wrap">
    <!--正常图片上传模式-->
    <div class="arr-wrap " ref="container" :class="{'indexLength':pattern}" v-if="!modifyTheImage">
      <!--图片数组-->
      <template v-for="(imgItem,index) in showArr">
        <div class="image-arr"   :key="index+listKey" v-if="index<indexLength">
          <img :src="$GFUN.formatImgSrc(imgItem,100,100)" class="w-100 h-100 rounded cursor-pointer" @click="imgPreview(index)">
          <div class="img-mask rounded" v-show="editMode">
            <i class="el-icon-zoom-in cursor-pointer" @click="imgPreview(index)"></i>
            <i class="el-icon-delete cursor-pointer" @click="deleteImg(index)"></i>
          </div>
        </div>
      </template>
      <div class="image-arr" v-if="pattern&&showArr.length>2">
        <p class="w-100 h-100 rounded cursor-pointer img-index">+{{ showArr.length-2 }}</p>
      </div>
      <div class="upload-btn" v-show="showUploadIcon">
        <input type="file" ref="referenceUpload" :multiple="multiMode" accept="image/*" @change="onRead"/>
        <i class="iconfont icon-tianjiajiahaowubiankuang  "></i>
      </div>
    </div>
    <!--弹出框图片上传模式-->
    <div v-if="modifyTheImage" class="w-100">
        <div class="uploadMode">
          <div class="leIcon">
            <i class="el-icon-upload"></i>
          </div>
          <p>点击至此处上传</p>
          <span>支持 JPG, PNG (建议尺寸 500x500),单张最大 1MB</span>
          <input type="file" ref="referenceUpload" :multiple="multiMode" accept="image/*" @change="onRead"/>
        </div>
        <div class="prompt">已上传展示图片({{ showArr.length }}/10)</div>
        <div ref="container" class="picture-list">
          <template v-for="(imgItem,index) in showArr">
            <div class="image-arr"   :key="index+listKey" v-if="index<indexLength">
              <img :src="$GFUN.formatImgSrc(imgItem,100,100)" class="w-100 h-100 rounded cursor-pointer" @click="imgPreview(index)">
              <div class="img-mask rounded" >
                <i class="el-icon-zoom-in cursor-pointer" @click="imgPreview(index)"></i>
                <i class="el-icon-delete cursor-pointer" @click="deleteImg(index)"></i>
              </div>
            </div>
          </template>
        </div>
    </div>
  </div>
</template>

<script>
import ImageCompressor from 'image-compressor.js';
import Sortable from 'sortablejs';
  export default {
    props: {
      existImgs: {},                                   //已存在的图片，为单文件时自动推入数组
      maxLength: {                                     //最大可上传的图片数
        type: Number,
        default: 20
      },
      indexLength: {                                      //缩略图展示
        type: Number,
        default: 99
      },
      pattern: {                                         //三张预览图模式
        type: Boolean,
        default: false
      },
      modifyTheImage: {                                  //开始弹窗单独修改图片
        type: Boolean,
        default: false
      },
      editMode: {                                        //是否为编辑模式
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        fileArr: [],
        imgArr: [],                                 //用来保存缩略图的图片展示，主要为base64格式和cdn图片地址格式
        listKey:0,
      }
    },
    watch: {
      existImgs (newVal) {
        if (newVal) this.initImgArr();
        else this.imgArr = [];
      }
    },
    mounted() {
      new Sortable(this.$refs.container, {
        animation: 150,
        onEnd: (evt) => {
        const { oldIndex, newIndex } = evt;
        this.$emit('fileChange', this.getNewList(oldIndex, newIndex));
        this.listKey += 1; // 手动触发重渲染
      }
      });
    },
    created() {
      if (this.existImgs) this.initImgArr();
    },
    computed: {
      //是否显示上传按钮
          showUploadIcon () {
            //编辑模式下图片小于最多可上传时显示上传按钮
            if (this.editMode) return this.imgArr.length < this.maxLength
            else return false
          },
          //是否为多选模式，当最大图片长度大于1时为多选
          multiMode () {
            return this.maxLength > 1;
          },
          //单选或多选模式下渲染的数组
          showArr() {
            return this.multiMode ? this.imgArr : this.imgArr.slice(0,1)
          }
        },
        methods: {
          //压缩图片
        compressFile(file) {
          return new Promise((resolve, reject) => {
            new ImageCompressor(file,{
              quality: 0.7,
              maxWidth:1920,
              success(result) {            
                resolve(result);
              },
            });
          });
        },
      /*初始化传入的图片数组到显示图片数组*/
      initImgArr() {  
        let str = ';base64,',exists = this.existImgs;
        if (!$.isArray(exists) && exists) {               //不是数组时作为数组元素推入数组
          let item = exists.indexOf(str) !== -1 ? exists : (this.ImgPreUrl + exists);
          this.imgArr.push(item);
        } else if ($.isArray(exists)) {                   //多张图片数组时拼接到imgArr中
          this.imgArr = this.existImgs.concat([])
        }
      },
      /*加载本地图片文件*/
      fileReaderPromise(file) {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = (e) => {resolve(e.target.result);}
        });
      },
      async onRead (e) {
        let files = e.target.files;
        const validImageTypes = ['image/jpeg','image/png','image/gif'];
        if (validImageTypes.includes(files[0].type)) {} else {
          this._alert('选择的文件不是有效的图片,请上传JPEG,PNG,GIF格式的文件。');
          return
        }
        //将文件对象转为数组格式
        this.fileArr = [];
        let handlePromise=[];
        for (let i = 0; i < files.length; i++) {
            handlePromise.push(files[i])
        };
        handlePromise = handlePromise.map(img => this.compressFile(img));
        this.fileArr = await Promise.all(handlePromise);
        //将所有文件转base64事件推入队列
          let filesPromise = this.fileArr.map(file => this.fileReaderPromise(file));
          let resultArr = await Promise.all(filesPromise);
          let totalArr = this.imgArr.concat(resultArr);
          if (totalArr.length > this.maxLength) {
            this._alert('照片最多只能上传' + this.maxLength + '张哦',null,'error');
            this.imgArr = totalArr.slice(0, this.maxLength);
          } else this.imgArr = totalArr;
          this.$emit('fileChange', this.imgArr)
          this.$refs.referenceUpload.value = null
  
      },
      /*图片预览*/
      imgPreview (index) {
        this._CarouselView({
          currentImg: index,
          picArray: this.imgArr
        })
      },
      /*本地删除某张图片*/
      deleteImg (index) {
        this.imgArr.splice(index, 1)
        this.$emit('fileChange', this.imgArr)
      },
      getNewList(oldIndex, newIndex) {
        const list = [...this.showArr];
        const [moved] = list.splice(oldIndex, 1);
        list.splice(newIndex, 0, moved);
        return list;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .arr-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .image-arr {
    width: 70px;
    height: 70px;
    position: relative;
    margin: 0 5px 10px 0;
    .img-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, .4);
      font-size: 20px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }

  .upload-btn {
    width: 70px;
    height: 70px;
    margin: 0 5px 10px 0;
    border: 1px dotted dodgerblue;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.2rem;
    position: relative;
    cursor: pointer;
    .icon-tianjiajiahaowubiankuang{
      font-size: 30px;
      color: #41baff;
    }
    input {
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .indexLength {
    padding-left: 20px;
  }
  .indexLength .image-arr{
    margin-bottom: 4px;
  }
  .indexLength .image-arr img,.img-index{
      box-shadow: 0px 0px 7px #eee;
      border: 2px #fff solid;
      border-radius: 10px !important;
      overflow: hidden;
  } 
  .indexLength .image-arr:not(:first-child){
    margin-left: -10px;
  }
  .img-index{
    background-color: #f5f5f5;
    line-height: 70px;
     margin-left: -10px;
  }
  .uploadMode{
    width: 94%;
    padding: 40px 3%;
    border: 1px #eee solid ;
    margin-top: 16px;
    background-color: #f5f5f5;
    text-align: center;
    position: relative;
  }
  .uploadMode input{
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  .uploadMode span{
    font-size: 12px;
    margin-top: 4px;
    display: block;
    color: #999;
  }
  .leIcon{
    width: 60px;
    height: 60px;
    background-color: #fff;
    border-radius: 50px;
    margin: 0 auto;
    margin-bottom: 6px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    i{
      font-size: 30px;
      color: #999;
    }
  }
  .prompt{
    padding: 10px 0;
  }
  .picture-list{
    width: 100%;
    overflow: auto;
    white-space: nowrap;
    margin-top: 4px;
    .image-arr{
      width: 90px;
      height: 90px;
      display: inline-block;
    }
  }
</style>
